import { useEffect } from 'react';

/**
 * SKANER — bitta qurilma, ekranlar esa ko'p.
 *
 * Skaner klaviatura bo'lgani uchun uni tinglash oyna darajasida bo'ladi
 * (`useBarcodeScanner`). Bu esa muammo tug'diradi: qobiqda umumiy skaner
 * turadi va u katak kodini ochadi, talabnoma berish oqimida esa O'Z skaneri
 * bor va u talabnoma raqamini kutadi. Ikkovi ham tinglasa, bitta skanerlash
 * ikki joyda ishlab ketardi — skladchi berish oqimining o'rtasida boshqa
 * sahifaga uchib qolardi.
 *
 * Shuning uchun ekran skanerni BAND QILADI. Band bo'lsa umumiy skaner
 * jim turadi; ekran yopilishi bilan band bo'shaydi.
 *
 * Sanoq (`claims`), bayroq emas: React qat'iy rejimda `useEffect` ni ikki
 * marta chaqiradi va bayroq bo'lsa ikkinchi tozalash bandni noto'g'ri
 * bo'shatib qo'yardi. Ichma-ich ikki ekran ham (dialog ustida dialog)
 * shu sanoq bilan to'g'ri ishlaydi.
 */
const state = { claims: 0 };

/** Umumiy skaner shu paytda jim turishi kerakmi. */
export const isScannerClaimed = (): boolean => state.claims > 0;

/** Band qilish — qaytgan funksiya bo'shatadi. Testlar uchun ochiq. */
export const claimScanner = (): (() => void) => {
  state.claims += 1;
  let released = false;
  return () => {
    // Ikki marta bo'shatish sanoqni manfiyga tushirmaydi.
    if (released) return;
    released = true;
    state.claims = Math.max(0, state.claims - 1);
  };
};

/**
 * Ekran ochiq turgan vaqt davomida skanerni band qiladi.
 *
 * `enabled` — shartli band qilish uchun: berish oqimi faqat skanerlash
 * bosqichida bandini oladi, dalolatnoma imzolayotganda esa yo'q.
 */
export const useScannerClaim = (enabled = true): void => {
  useEffect(() => {
    if (!enabled) return;
    return claimScanner();
  }, [enabled]);
};
